import React from "react";

const InfoCard = ({ title, description, icon: Icon }) => {
  return (
    <div className="flex items-center h-[10vh] xl:h-[15vh] text-white rounded-md bg-gradient-to-r from-pink-500 to-mariposa px-5 py-2 gap-x-4 flex-grow">
      <div className="flex flex-col gap-y-1 font-Roboto">
        <span className="lining-nums text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold ">
          {description}
        </span>
        <span className="font-semibold text-md md:text-lg lg:text-xl xl:text-2xl">
          {title}
        </span>
      </div>

      <div className="flex justify-end xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold ml-auto">
        <Icon />
      </div>
    </div>
  );
};

export default InfoCard;
